import { render, staticRenderFns } from "./PorPlazasAbonos.vue?vue&type=template&id=3fc82550"
import script from "./PorPlazasAbonos.vue?vue&type=script&lang=js"
export * from "./PorPlazasAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports